import React from 'react';
import {withRouter} from 'react-router-dom';
import {inject} from 'mobx-react';
import Michael from './Michael.png';
import Joe from './Joe.png';
import Leah from './Leah.png';
import Shannon from './Shannon.png';
import WhatWeDo from './WhatWeDo';
import OurTeam from './OurTeam';
import './styles.css';

const SCREENS = {
  WHAT_WEE_DO: 'WHAT_WEE_DO',
  OUR_TEAM: 'OUR_TEAM',
};
const TEAM = [{
  id: 1,
  full_name: 'Michael O’Carroll ',
  avatar: Michael,
  role: 'Founder & CEO',
  description: 'Michael is co-founder and CEO of Therapy Academy and a practicing therapist in Sandyford, Co Dublin. He has a BSc in Counselling & Psychotherapy and an accredited member of the Irish Association for Counselling and Psychotherapy (IACP). He previously worked for Cuan Mhuire and Pieta House before setting up a private practice.',
  second_description: 'As a counsellor and psychotherapist working in a private practice, he is committed to continuing his own learning and development. His vision for Therapy Academy is to provide high quality online CPD training for therapists and those working in the mental health sector.',
}, {
  id: 2,
  full_name: 'Joe Newell',
  avatar: Joe,
  role: 'Founder',
  description: 'Joe is co-founder of Therapy Academy. He has spent more than ten years working in technology startups. He is currently CEO of GPBuddy.ie, an online resource for Irish GPs.',
  second_description: 'He also founded MedCafe.ie, a webinar and live streaming platform for healthcare professionals. In 2007, Joe received his MBA from the Wharton School, University of Pennsylvania. He graduated from UCD with a degree in Electronic Engineering in 2000.',
},
// {
//   id: 3,
//   full_name: 'Shannon Sweeney',
//   avatar: Shannon,
//   role: 'Customer Support Specialist',
//   description: 'Shannon joined the Therapy Hub team in 2020 as a Customer Support Specialist. She has a background in mental health and youth work in the voluntary sector.',
//   second_description: 'Shannon has experience in content writing for blogs and social media, specialising in mental health, science and community stories. Shannon holds a B.A in Psychology & Sociology from the University of Limerick.',
// },
{
  id: 4,
  full_name: 'Leah Johnston',
  avatar: Leah,
  role: 'Project Manager',
  description: 'Leah joined Therapy Academy in March 2020. She brings over 15 years experience in Project and Event Management. She has experience creating and implementing in-person and online programmes.',
  second_description: 'Leah brings a wealth of experience from Arts & Culture sector and has delivered festivals and arts events throughout Ireland. Leah loves helping people to implement high quality programme and then connecting them with those who will enjoy it.',
},
];

@withRouter
@inject('user')
export default class AboutUs extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedScreen: SCREENS.WHAT_WEE_DO,
    };
  }

  handleScreen = event => {
    this.setState({selectedScreen: event.target.id});
  }

  renderContent = selectedScreen => {
    switch(selectedScreen) {
      case SCREENS.WHAT_WEE_DO:
        return <WhatWeDo />;
      case SCREENS.OUR_TEAM:
        return <OurTeam team={TEAM} />;
      default:
        return null;
    };
  }

  render() {
    const {selectedScreen} = this.state;
    return(
      <main className="main-content dark-background">
        <section className="container-fluid">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <div className="invest-inner">
                  <div className="invest-holder">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 786.3 426">

                      <path d="M502.9 364.6l20.8-12c13.6-7.9 18.3-25.3 10.4-38.9l-12-20.8c-7.9-13.6-25.3-18.3-38.9-10.4l-20.8 12c-13.6 7.9-18.3 25.3-10.4 38.9l12 20.8c7.9 13.6 25.3 18.2 38.9 10.4zM283.4 364.6l-20.8-12c-13.6-7.9-18.3-25.3-10.4-38.9l12-20.8c7.9-13.6 25.3-18.3 38.9-10.4l20.8 12c13.6 7.9 18.3 25.3 10.4 38.9l-12 20.8c-7.9 13.6-25.3 18.2-38.9 10.4z"
                            className="st0"/>
                      <path d="M282.1 343c0 35.3 28.7 64 64 64h94c35.3 0 64-28.7 64-64v-59c0-35.3-28.7-64-64-64h-94c-35.3 0-64 28.7-64 64v59z"
                            className="st0"/>
                      <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 15.9-7.1 30.5-19 42.1v.5l47 47 47-47v-.5c-11.8-11.6-19-26.2-19-42.1z"
                            className="st1"/>
                      <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 4.5-.6 8.8-1.6 13l19.2 11.6c6.4 3.9 14.5 3.9 20.9 0l19.2-11.6c-1.1-4.2-1.7-8.5-1.7-13z"
                            className="st2"/>
                      <path d="M433.5 176l-29.9 18.1c-6.4 3.9-14.5 3.9-20.9 0L352.8 176c-9.6-5.8-15.7-15.9-16.5-27.1L329.1 48h128L450 148.9c-.8 11.2-7 21.3-16.5 27.1z"
                            className="st3"/>
                      <path d="M410.1 137.5l16-1M360.1 136.5l16 1" className="st4"/>
                      <path d="M132.6 421h521" className="st5"/>
                      <path d="M452.4 114.9l4.7-67h-128l5.8 81.1c4-3.5 8.6-6.4 13.6-8.6 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 .1.1 19.9 8.8 32.3 25.5z"
                            className="st6"/>
                      <path d="M411.1 12c-59-24-99 31.8-99 81 0 15.3 3.9 29.7 10.7 42.3 4.8-10.9 14.1-19.8 25.7-24.8 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 0 0 40 17.5 42 50.9.3 4.3 1.5 8.4 1.8 12.5 11.2-12.7 18.2-30.5 18.2-50.3 0-19.6-10-80.6-71-80.6z"
                            className="st7"/>
                      <path d="M268.3 387c0 11 9 20 20 20H498c11 0 20-9 20-20V255c0-11-9-20-20-20H288.3c-11 0-20 9-20 20v132z"
                            className="st8"/>
                      <circle cx="393.1" cy="321" r="24" className="st9"/>
                      <path d="M271.6 398c3.6 5.4 9.7 9 16.7 9H498c7 0 13.1-3.6 16.7-9H271.6z"
                            className="st10"/>
                      <path d="M201.1 88.2l-39 28.6c-3 2.2-7.3.1-7.3-3.7V55.9c0-3.8 4.3-5.9 7.3-3.7l39 28.6c2.5 1.8 2.5 5.6 0 7.4zM89.7 84.5h35.8M219.9 54.5h16M690.6 198.7h-17.4v-17.4c0-4.6-3.8-8.4-8.4-8.4H652c-4.6 0-8.4 3.8-8.4 8.4v17.4h-17.4c-4.6 0-8.4 3.8-8.4 8.4V220c0 4.6 3.8 8.4 8.4 8.4h17.4v17.4c0 4.6 3.8 8.4 8.4 8.4h12.9c4.6 0 8.4-3.8 8.4-8.4v-17.4h17.4c4.6 0 8.4-3.8 8.4-8.4v-12.9c-.1-4.6-3.9-8.4-8.5-8.4zM783.3 213.6h-52.8M746.4 183.6h-29.6M84.5 298.4l34-75M152.5 298.4l-34-75M98 269h41"
                            className="st11"/>
                      <g>
                        <path d="M170 260.9h32M186 244.9v32" className="st11"/>
                      </g>
                      <path d="M80 234H49M60 264H3M63 114.5h62.5M601.5 33.5L625 57M679 3l-54 54M552 134l50.5-50.5M560 86l22.5-22.5"
                            className="st11"/>
                    </svg>
                    <div className="shadow" style={{top: 0}} />
                  </div>
                  {/* <p className="invest-slogan">About us</p>
                  <ul className="invest-professions">
                    <li>Therapy Academy is an online resource for therapists and those concerned with the mental health field to take CPD workshops and further their expertise.</li>
                  </ul> */}
                  {/* <div className="invest-btn-holder au-btn-holder">
                    <span
                      className={`${selectedScreen === SCREENS.WHAT_WEE_DO ? 'btn prime bordered' : ''} btn add-workshop`}
                      id={SCREENS.WHAT_WEE_DO}
                      onClick={this.handleScreen}
                    >
                      What we do
                    </span>
                    <span
                      className={`${selectedScreen === SCREENS.OUR_TEAM ? 'btn prime bordered' : ''} btn add-workshop`}
                      id={SCREENS.OUR_TEAM}
                      onClick={this.handleScreen}
                    >
                      Our team
                    </span>
                  </div> */}
                  {/* {this.renderContent(selectedScreen)} */}
                  <WhatWeDo />
                  <OurTeam team={TEAM} />
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/informations/aboutUs/index.jsx